import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "../context/AuthContext";
import { Input } from "../components/ui/input";
import { toast } from "sonner";
import GrainOverlay from "../components/GrainOverlay";

const HERO = "https://customer-assets.emergentagent.com/job_ai-agent-builder-135/artifacts/s8r4h7c5_%CE%A3%CF%84%CE%B9%CE%B3%CE%BC%CE%B9%CF%8C%CF%84%CF%85%CF%80%CE%BF%20%CE%BF%CE%B8%CF%8C%CE%BD%CE%B7%CF%82%202026-04-20%20214621.png";

export default function Login() {
  const { login } = useAuth();
  const nav = useNavigate();
  const [pw, setPw] = useState("");
  const [busy, setBusy] = useState(false);

  // Check if user completed OTP first
  useEffect(() => {
    const otpCompleted = localStorage.getItem("otp_verified");
    if (!otpCompleted) {
      toast.error("Please complete OTP verification first");
      nav("/gpcrmcontrol");
    }
  }, [nav]);

  const submit = async (e) => {
    e.preventDefault();
    if (!pw) return;
    setBusy(true);
    try {
      await login(pw);
      localStorage.removeItem("otp_verified"); // Clear OTP flag
      toast.success("Welcome back, κούκλε");
      nav("/crm");
    } catch (err) {
      toast.error(err?.response?.data?.detail || "Wrong password");
    } finally {
      setBusy(false);
    }
  };

  return (
    <div className="min-h-screen bg-black text-white grid lg:grid-cols-2 relative overflow-hidden" data-testid="login-page">
      <GrainOverlay />

      {/* Left image panel */}
      <div className="hidden lg:block relative">
        <img src={HERO} alt="" className="absolute inset-0 w-full h-full object-cover" />
        <div className="absolute inset-0 bg-black/60" />
        <div className="absolute bottom-12 left-12 z-10 max-w-md">
          <div className="overline text-[color:var(--gio-primary)] mb-6">GP APP · PERSONAL</div>
          <h2 className="font-heading text-5xl text-white leading-[0.95]">
            Your agent.<br/>
            <span className="italic text-zinc-400">Your brand.</span><br/>
            Amplified.
          </h2>
          <div className="overline mt-8">EN / ΕΛΛ · XAI GROK</div>
        </div>
      </div>

      {/* Right login panel */}
      <div className="flex items-center justify-center p-8 lg:p-16 relative z-10">
        <form onSubmit={submit} className="w-full max-w-sm fade-up" data-testid="login-form">
          <div className="overline mb-4">001 · ACCESS</div>
          <h1 className="font-heading text-5xl text-white mb-2 tracking-tight">Enter the lounge</h1>
          <p className="text-zinc-500 text-sm mb-10">Single password. No fuss. Μόνο για σένα.</p>

          <label className="overline block mb-3" htmlFor="pw">Password</label>
          <Input
            id="pw"
            type="password"
            value={pw}
            onChange={(e) => setPw(e.target.value)}
            placeholder="••••••••"
            autoFocus
            data-testid="login-password-input"
            className="h-14 bg-zinc-950 border-zinc-800 text-white rounded-none focus-visible:ring-0 focus-visible:border-[color:var(--gio-primary)] text-lg"
          />

          <button
            type="submit"
            disabled={busy}
            data-testid="login-submit-button"
            className="btn-primary w-full mt-8 disabled:opacity-50"
          >
            {busy ? "Unlocking..." : "Unlock GP App →"}
          </button>

          <div className="overline mt-10 text-zinc-700">v0.1 · Built for GP</div>
        </form>
      </div>
    </div>
  );
}
